<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-14
 * @Description: 营销管理/平台营销工具/平台卡券活动/详情
-->
<template>
  <scroll-layout class="scan-coupons-detail">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div>
      <ykc-detail :titles="['活动信息']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="80px" class="list-left">
              <ykc-detail-item label="活动名称：">
                <span>{{ dealData(detail.activityName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="对外名称：">
                <span>{{ dealData(detail.outName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动简介：">
                <span class="text-wrap">{{ dealData(detail.activityDesc) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动类型：">
                <span>充电任务</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动状态：">
                <span>{{ statusLabel(detail.activityStatus) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动时间：">
                <span>
                  {{ dealData(detail.activityBeginTime) }} ~{{ dealData(detail.activityEndTime) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="修改时间：">
                <span>{{ dealData(detail.modifiedTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="修改人：">
                <span>{{ dealData(detail.modifiedBy) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建时间：">
                <span>{{ dealData(detail.createdTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建人：">
                <span>{{ dealData(detail.createdBy) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="小程序链接：">
                {{
                  dealData(
                    `/pagesMyCenter/chargeTask/chargeActivity?activityId=${detail.activityId}`
                  )
                }}
                <span
                  class="copy"
                  @click="
                    copyActivity(
                      `/pagesMyCenter/chargeTask/chargeActivity?activityId=${detail.activityId}`
                    )
                  "></span>
              </ykc-detail-item>
              <ykc-detail-item label="活动说明：">
                <span class="text-wrap">{{ dealData(detail.activityRemark) }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
      <ykc-detail :titles="['活动配置']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="100px" class="list-left">
              <ykc-detail-item label="任务类别: ">
                <span>
                  {{ dealTaskData(detail) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="卡券设置：">
                <ykc-table
                  :columns="tableColumns"
                  :tableConfig="tbConfig"
                  :data="detail.taskGroupList || []"></ykc-table>
              </ykc-detail-item>
              <ykc-detail-item label="活动范围: ">
                <span>
                  {{ cityScopeLabel(detail.cityScope) }}
                </span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
      <div class="onlineConent" v-if="detail.cityScope !== '3'">
        <ykc-detail :isHead="false" :tips="false" :className="'all'">
          <div slot="cvBody">
            <div slot="first">
              <ykc-tabs
                :tabList="tabList"
                :active="activeName"
                headerButtonText="导出"
                :showHeaderButtons="showDownloadBtn"
                @btnClick="clickExport()"
                :rightHeaderNoMarginTop="true"></ykc-tabs>
              <ykc-table
                ref="YkcTable"
                :data="stationTableData"
                :columns="stationTableColumns"
                headerButtonText="导出"
                :showHeaderButtons="showDownloadBtn"
                @btnClick="clickExport()"
                :rightHeaderNoMarginTop="true">
                <ykc-pagination
                  :total="stationTabTotal"
                  slot="pagination"
                  :pageSize.sync="stationTabPageSize"
                  :currentPage="stationTabCurrentPage"
                  @size-change="handleStationTabSizeChange"
                  @current-change="handleStationTabCurrentChange" />
              </ykc-table>
            </div>
          </div>
        </ykc-detail>
      </div>
    </div>
  </scroll-layout>
</template>

<script>
  import { couponActivity } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    props: {
      activityId: {
        type: String,
      },
    },
    data() {
      return {
        cityScopeDes: {
          4: '按城市选择',
          1: '按商户选择',
          2: '按电站分组',
          3: '全部电站',
        },
        searchItems: [
          {
            comName: 'YkcInput',
            key: 'stationId',
            label: '电站编码',
            placeholder: '请输入电站编码',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
        ],
        searchParams: {},
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        defaultImageUrl: '',
        detail: {},
        carProperty: [],
        tbConfig: {
          stripe: false,
          border: false,
          // eslint-disable-next-line consistent-return
          spanMethod: ({ rowIndex, columnIndex }) => {
            console.log('rowIndex :>> ', rowIndex);
            console.log('columnIndex :>> ', columnIndex);
            // if (columnIndex === 0) {
            //   // 用于设置要合并的列
            //   const size = this.mergeRows.length;
            //   if (size > 0) {
            //     for (let i = 0; i < size; i++) {
            //       const item = this.mergeRows[i];
            //       if (rowIndex === item.startRow && item.count > 1) {
            //         return {
            //           rowspan: item.count, // 合并的行数
            //           colspan: 1, // 合并的列数，设为０则直接不显示
            //         };
            //       }
            //       if (rowIndex < item.startRow + item.count) {
            //         return {
            //           rowspan: 0,
            //           colspan: 0,
            //         };
            //       }
            //     }
            //   }
            // }
          },
        },
        mergeRows: [], // 需要合并的行
        tableColumns: [
          {
            label: '梯度',
            prop: 'group',
            width: 150,
          },
          {
            label: '卡券名称',
            prop: 'cardCouponName',
            width: 240,
            scopedSlots: {
              default: ({ row }) => {
                if (row.cardCouponType === 1 || row.cardCouponType === 2) {
                  return (
                    <el-link type="primary" onClick={() => this.handleCellClick(row)}>
                      {row.cardCouponName}
                    </el-link>
                  );
                }
                return <span>{row.cardCouponName}</span>;
              },
            },
          },
          {
            label: '卡券对外名称',
            prop: 'outName',
            width: 240,
          },
          { label: '发放数量(张/人)', prop: 'num', width: 240 },
        ],
        firstTableData: [],
        firstTableColumns: [
          { label: '电站编码', prop: 'stationId', minWidth: '150px' },
          { label: '电站名称', prop: 'stationName', minWidth: '150px' },
          { label: '电站类型', prop: 'stationType', minWidth: '150px' },
          { label: '归属商户', prop: 'belongOperation', minWidth: '150px' },
          { label: '电站分组', prop: 'stationGroup', minWidth: '150px' },
        ],
        total: 10,
        pageSize: 10,
        currentPage: 1,
        stationTableData: [],
        stationTableColumns: [
          { label: '电站编码', prop: 'dataId', minWidth: '150px' },
          { label: '电站名称', prop: 'dataName', minWidth: '150px' },
          {
            label: '电站类型',
            prop: 'stationTypeText',
            minWidth: '150px',
          },
          { label: '归属商户', prop: 'stationOperatorName', minWidth: '150px' },
        ],
        tabList: [
          {
            label: '活动站点列表',
            name: 'first',
          },
        ],
        userTableData: [],
        userTableColumns: [],
        activeName: 'first',
        stationTabTotal: 10,
        stationTabPageSize: 10,
        stationTabCurrentPage: 1,
        userTabTotal: 10,
        userTabPageSize: 10,
        userTabCurrentPage: 1,
        showDownloadBtn: false,
        qrcodeImg: '',
        qrcodeImg1: '',
      };
    },
    computed: {},
    created() {
      this.showDownloadBtn = true; // 或者根据实际权限控制
      this.getDetail();
    },
    methods: {
      // eslint-disable-next-line consistent-return

      dicStatus() {
        // 活动状态（1:进行中，2:未开始，3:已结束(手动停用)，4:已结束(活动到期)，5:已结束(卡券不足)，6:已结束(卡券失效)）
        return [
          { id: '1', name: '进行中' },
          { id: '2', name: '未开始' },
          { id: '3', name: '已结束(手动停用)' },
          { id: '4', name: '已结束(活动到期)' },
          { id: '5', name: '已结束(卡券不足)' },
          { id: '6', name: '已结束(卡券失效)' },
        ];
      },
      statusLabel(status) {
        if (!status) {
          return '——';
        }
        const obj = this.dicStatus()?.find(item => item.id === status);
        return obj?.name || '——';
      },
      handleSizeChange() {
        console.log('使用了sync修饰符', this.pageSize);
      },
      handleCurrentChange(val) {
        console.log('没有使用了sync修饰符', val);
      },

      handleCellClick(row) {
        if (row.cardCouponType === 1) {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard',
            query: {
              data: row.cardCouponId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else if (row.cardCouponType === 2) {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon',
            query: {
              data: row.cardCouponId,
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      },

      clickExport() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'chargeTaskActivityStationList',
            activityId: this.activityId,
          },
        });
      },

      /**
       * 获取详情数据
       */
      getDetail() {
        couponActivity.chargeTaskActivityDetail({ activityId: this.activityId }).then(res => {
          if (res) {
            this.detail = res || {};
            console.log('this.detail', this.detail);
            // 参考充值领取活动的实现，仅在cityScope !== '3'时调用getStations
            if (res.cityScope !== '3') {
              this.getStations();
            }
            this.setMergeRows();
          }
        });
      },
      fixTabsHeaders() {
        // 根据活动详情设置标签页的列定义
        // 这里可以根据实际需求进行调整
        if (this.detail.stationScope === '1' || this.detail.stationScope === '4') {
          this.stationTableColumns = [
            { label: '电站编码', prop: 'dataId', minWidth: '150px' },
            { label: '电站名称', prop: 'dataName', minWidth: '150px' },
            { label: '电站类型', prop: 'stationTypeText', minWidth: '150px' },
            { label: '归属商户', prop: 'stationOperatorName', minWidth: '150px' },
          ];
        } else if (this.detail.stationScope === '2') {
          this.stationTableColumns = [
            { label: '电站分组', prop: 'dataName', minWidth: '150px' },
            { label: '电站数量', prop: 'stationCount', minWidth: '150px' },
          ];
        }
      },
      setMergeRows() {
        if (this.detail?.rewardList?.length > 0) {
          let mergedStart = -1;
          let mergedCount = 0;
          let lasThreshold = -1;
          for (let i = 0; i < this.detail.rewardList.length; i++) {
            const reward = this.detail.rewardList[i];
            if (reward.rewardThreshold !== lasThreshold) {
              // 梯度和上个不一样，说明是一个新的梯度，梯度变化了
              if (mergedStart >= 0 && mergedCount > 0) {
                this.mergeRows.push({
                  startRow: mergedStart,
                  count: mergedCount,
                });
              }
              lasThreshold = reward.rewardThreshold;
              mergedStart = i;
              mergedCount = 1;
            } else {
              mergedCount++;
              if (i === this.detail.rewardList.length - 1) {
                // 最后一个也要设置一下
                if (mergedStart >= 0 && mergedCount > 0) {
                  this.mergeRows.push({
                    startRow: mergedStart,
                    count: mergedCount,
                  });
                }
              }
            }
          }
          //      mergeRows;
        }
      },
      dealData(data) {
        return data || '—';
      },
      dealTaskData(data) {
        if (data.chargeType === 1) {
          return '按充电度数';
        }
        if (data.chargeType === 2) {
          if (data.chargingCountDegree === null) {
            return '按充电次数';
          }
          return `按充电次数，每次充电度数满${data.chargingCountDegree}度才计数`;
        }
        return '—';
      },
      cityScopeLabel(cityScope) {
        if (!cityScope) {
          return '——';
        }
        const obj = this.cityScopeDes?.[cityScope];
        return obj || '——';
      },
      /**
       * 获取字典
       */
      getDic(id) {
        const [property] = this.carProperty.filter(item => item.id === id);
        return property.name || '—';
      },
      /**
       * 获取用户信息
       */
      getUsers() {
        // 如果需要实现用户列表功能，可以在这里添加相应的API调用
        // 目前充电任务活动可能没有用户列表功能
      },
      getStations() {
        couponActivity
          .chargeTaskStation({
            activityId: this.activityId,
            current: this.stationTabCurrentPage,
            size: this.stationTabPageSize,
            ...(this.searchParams || {}),
          })
          .then(res => {
            if (res) {
              this.stationTableData = res?.records || [];
              this.stationTabTotal = res?.total;
            }
          });
      },
      handleTabChange(activeName) {
        this.activeName = activeName;
      },
      handleStationTabSizeChange(size) {
        console.log('使用了sync修饰符', this.pageSize);
        this.stationTabPageSize = size;
        this.getStations();
      },
      handleStationTabCurrentChange(currentPage) {
        console.log('没有使用了sync修饰符', currentPage);
        this.stationTabCurrentPage = currentPage;
        this.getStations();
      },
      handleUserTabSizeChange(size) {
        console.log('使用了sync修饰符', this.pageSize);
        this.userTabPageSize = size;
        this.getUsers();
      },
      handleUserTabCurrentChange(currentPage) {
        console.log('没有使用了sync修饰符', currentPage);
        this.userTabCurrentPage = currentPage;
        this.getUsers();
      },
      copyActivity(str) {
        this.$copyText(str)
          .then((e, err) => {
            if (e) {
              this.$message.success('复制成功');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },
      handleSearchConfirm(form) {
        this.stationTabCurrentPage = 1;
        const search = JSON.parse(JSON.stringify(form));
        this.searchParams = search || {};
        this.getStations();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .text-wrap {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .scan-coupons-detail {
    .all {
      margin-bottom: 16px;
    }
    .form-detail .ykc-detail-item-box {
      .ykc-table {
        padding: 0;
      }
    }
    .copy {
      margin-left: 6px;
      width: 14px;
      cursor: pointer;
      background: url('~@/assets/images/staging/copy.png') no-repeat 100%;
    }
    .activity-photo {
      width: 80px;
      height: 80px;
      background: #f5f8ff;
      border-radius: 10px;
      img {
        width: 80px;
        height: 80px;
        border-radius: 10px;
      }
    }
  }
</style>
